{
  "version": 1,
  "asset_id": "8e631f69-7448-4dfc-9b7e-c4be2a2f180e",
  "project_id": "06d7597f-1046-443d-83bd-ddf3abafe47c",
  "url": "/__l5e/assets-v1/8e631f69-7448-4dfc-9b7e-c4be2a2f180e/logo-investcapital-v4.png",
  "r2_key": "a/v1/06d7597f-1046-443d-83bd-ddf3abafe47c/8e631f69-7448-4dfc-9b7e-c4be2a2f180e/logo-investcapital-v4.png",
  "original_filename": "logo-investcapital-v4.png",
  "size": 22892,
  "content_type": "image/png",
  "created_at": "2026-07-29T12:22:59Z"
}
